/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface UpdateDeviceRemoteActionDto {
  /** Name of the remote action */
  name?: string;
  /** The action to perform on the remote device */
  remoteDeviceActionPointId?: string;
}
